module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon10.png?11dede58";